/** Resolve footer env URLs; use fallback when unset or blank. */

function envLink(raw: string | undefined, fallback: string): string {
  const t = (raw ?? "").trim();
  return t || fallback;
}

export const FOOTER_ABOUT_US_URL = envLink(
  process.env.REACT_APP_ABOUT_US_URL,
  "https://oneplay.in"
);

export const FOOTER_FAQ_URL = envLink(
  process.env.REACT_APP_FAQ_URL,
  "https://oneplay.in"
);

export const FOOTER_CONTACT_US_URL = envLink(
  process.env.REACT_APP_CONTACT_US_URL,
  "/contact-us"
);

export const FOOTER_BLOGS_URL = envLink(
  process.env.REACT_APP_BLOGS_URL,
  "https://medium.com/@oneplay_gaming"
);

export const FOOTER_TERMS_URL = envLink(
  process.env.REACT_APP_TERMS_AND_CONDITIONS_URL,
  "/terms-and-conditions"
);

export const FOOTER_PRIVACY_URL = envLink(
  process.env.REACT_APP_PRIVACY_POLICY_URL,
  "/privacy-policy"
);

export const FOOTER_SHIPPING_DELIVERY_URL = envLink(
  process.env.REACT_APP_SHIPPING_DELIVERY_URL,
  "/shipping-and-delivery"
);

export const FOOTER_REFUND_POLICY_URL = envLink(
  process.env.REACT_APP_REFUND_POLICY_URL,
  "/refund-and-cancellation-policy"
);

export function isExternalFooterUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
